// src/components/ui/achievement-badge.tsx
"use client"

import { LucideIcon } from "lucide-react"

interface AchievementBadgeProps {
  icon: LucideIcon
  isUnlocked: boolean
  name?: string
  description?: string
  color: string
  themeColors: {
    primary: string
    secondary: string
    background: string
    foreground: string
    muted: string
    border: string
  }
}

export function AchievementBadge({ 
  icon: Icon, 
  isUnlocked, 
  name, 
  description,
  color,
  themeColors 
}: AchievementBadgeProps) {
  return (
    <div className="flex flex-col items-center">
      <div 
        className={`w-16 h-16 rounded-full flex items-center justify-center relative transition-all duration-300 ${!isUnlocked ? 'grayscale opacity-50' : 'hover:scale-110'}`}
        style={{ 
          backgroundColor: `${color}20`,
          border: `2px solid ${isUnlocked ? color : themeColors.border}`
        }}
      >
        <Icon 
          className="w-8 h-8" 
          style={{ color: isUnlocked ? color : themeColors.border }}
        />
        
        {!isUnlocked && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div 
              className="w-6 h-6 rounded-full flex items-center justify-center"
              style={{ backgroundColor: themeColors.border }}
            >
              <span 
                className="text-xs font-bold"
                style={{ color: themeColors.foreground }}
              >
                ?
              </span>
            </div>
          </div>
        )}
        
        {isUnlocked && (
          <div 
            className="absolute -top-1 -right-1 w-5 h-5 rounded-full flex items-center justify-center"
            style={{ backgroundColor: color }}
          >
            <span className="text-xs text-white">✓</span>
          </div>
        )}
      </div>
      
      {name && (
        <p 
          className="text-xs text-center mt-2 font-medium"
          style={{ color: themeColors.foreground }}
        >
          {name}
        </p>
      )}
    </div>
  )
}